export default __webpack_public_path__ + "static/media/clock.d9f4fc3c.svg";